import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Track click-to-call button clicks
 */
export const trackCallClick = async (callerPhone = null) => {
  try {
    await axios.post(`${BACKEND_URL}/api/tracking/call-click`, {
      caller_phone: callerPhone,
      source: 'website_click_to_call'
    });
    console.log('Call click tracked');
  } catch (error) {
    console.error('Failed to track call click:', error);
  }
};

/**
 * Track WhatsApp button clicks
 */
export const trackWhatsAppClick = async (phone = null) => {
  try {
    await axios.post(`${BACKEND_URL}/api/tracking/whatsapp-click`, {
      phone: phone
    });
    console.log('WhatsApp click tracked');
  } catch (error) {
    console.error('Failed to track WhatsApp click:', error);
  }
};

/**
 * Handle email click with tracking
 */
export const handleEmailClick = (email) => {
  window.location.href = `mailto:${email}`;
};

/**
 * Handle WhatsApp click with tracking
 * Opens WhatsApp chat and tracks the click
 */
export const handleWhatsAppClick = (phoneNumber, message = '') => {
  trackWhatsAppClick(phoneNumber);
  
  // Format phone number (remove spaces, dashes, etc.)
  const formattedPhone = phoneNumber.replace(/\D/g, '');
  
  // Create WhatsApp URL
  const whatsappURL = `https://wa.me/${formattedPhone}${message ? `?text=${encodeURIComponent(message)}` : ''}`;
  
  // Open WhatsApp in new tab
  window.open(whatsappURL, '_blank');
};
